import { useStopWatchCountDown } from "global-components-library";

import { useEffect, useState } from "react";

const StopWatchCountDown = ({ hours = 0, minutes = 0, secondsInitial = 0, onChange }) => {
  let { start, stop, fullFormat, seconds } = useStopWatchCountDown(hours, minutes, secondsInitial);
  const [complete, setComplete] = useState("00:00:00");

  useEffect(() => {
    start();
    return () => {
      stop();
    }
  }, []);

  useEffect(() => {
    let result = fullFormat();
    onChange(result);
    setComplete(result);
  }, [seconds]);

  return complete;
};

export default StopWatchCountDown;



// WEBPACK FOOTER //
// ./src/components/Header/StopWatch/StopWatchCountDown.jsx